
const messages = {
  en: {
    producto: {
      title: 'Producto management',
      menuTitle: 'Products',
      subtitle: 'View, search, create, edit and delete Producto',
      creating: 'Creating Producto',
      editing: 'Editing Producto',
      deleting: 'Deleting Producto',
      showing: 'Showing Producto',
      addedToCsv: 'Producto added to csv',
      errorHasStock: 'The selected producto has stock. It cannot be deleted',
      filters: 'Filters',
      filterSection: {
        identification: 'Identification',
        numeric: 'Values',
        state: 'State',
        deposito: 'Warehouse',
        proveedor: 'Supplier',
      },
      filterDepositoAll: 'All warehouses',
      operators: {
        label: 'Operator',
        gte: 'Greater or equal',
        lte: 'Less or equal',
        eq: 'Equal to',
      },
      actions: {
        createOferta: 'Create Offer',
        transferirStock: 'Transfer Stock',
        agregarStock: 'Add Stock',
        cambioMasivoPrecio: 'Bulk Price Change',
        edicionMasivaAtributos: 'Bulk edit brand / model / size',
        clearFilters: 'Clear Filters',
        applyFilters: 'Apply Filters',
        columnasVisibles: 'Visible columns',
        seleccionarTodas: 'Select all',
        limpiarColumnas: 'Clear',
        editarTabla: 'Edit table',
        addToPresupuestoPedido: 'Add to quote/sales order',
        addToOrdenCompra: 'Add to purchase order',
      },
      modals: {
        createOferta: {
          title: 'Create Offer',
          message: 'You are about to create an offer with {count} selected products. Do you want to continue?',
        },
        transferirStock: {
          title: 'Transfer Stock',
          depositoDestino: 'Destination Warehouse',
          cantidad: 'Quantity',
          stockDisponible: 'Available Stock',
          productosSeleccionados: 'Selected Products',
          errorCantidadRequerida: 'Quantity is required',
          errorCantidadMinima: 'Quantity must be greater than 0',
          errorCantidadExcede: 'Quantity cannot exceed available stock',
          errorDepositoRequerido: 'Destination warehouse is required',
          errorValidacion: 'Please check all fields and quantities',
          errorTransferencia: 'Error transferring stock',
          success: 'Stock transferred successfully',
          warningDepositosDiferentes: 'Selected products are from different warehouses. Please select products from the same warehouse.',
        },
        agregarStock: {
          title: 'Add Stock',
          productosSeleccionados: 'Selected Products',
          stockDisponible: 'Available Stock',
          cantidadAgregar: 'Quantity to Add',
          nuevoStockFinal: 'New Final Stock',
          errorCantidadNegativa: 'Quantity cannot be negative',
          errorValidacion: 'Please add at least one quantity to confirm',
          success: 'Stock added successfully',
          error: 'Error adding stock',
        },
        cambioMasivoPrecio: {
          title: 'Bulk Price Update',
          precioCompraGlobal: 'Purchase Price',
          ivaGlobal: 'VAT',
          descuentoGlobal: 'Supplier Discount',
          margenGlobal: 'Profit Margin',
          tipoRedondeo: 'Rounding Type',
          productosSeleccionados: 'Selected Products',
          precioVentaActual: 'Current Price',
          precioVentaNuevo: 'New Selling Price',
          diferencia: 'Difference',
          success: 'Prices updated successfully',
          error: 'Error updating prices',
          hint: 'Values are automatically applied to all products. You can edit them individually in the table.',
        },
        edicionMasivaAtributos: {
          title: 'Bulk edit attributes',
          otrasHint: 'If you type text here, it is applied to all selected products; leave empty to leave this field unchanged.',
          productosSeleccionados: 'Selected products',
          success: 'Products updated successfully',
          error: 'Error updating products',
        },
        presupuestoPedido: {
          title: 'Create quote or sales order from products',
          basketCount: '{count} product(s) for quote/order',
          openModal: 'View and create quote or sales order',
          clearBasket: 'Clear selection for quote/order',
          cliente: 'Customer',
          tipoDocumento: 'Document type',
          tipoPresupuesto: 'Quote',
          tipoPedido: 'Sales order',
          producto: 'Product',
          cantidad: 'Quantity',
          precioUnitario: 'Unit price',
          subtotal: 'Subtotal',
          crear: 'Create',
          cancelar: 'Cancel',
          errorDeposito: 'Select a warehouse in your user configuration to create quotes or orders.',
          errorCliente: 'Customer is required',
          errorItems: 'Add at least one product with quantity ≥ 1',
        },
        ordenCompra: {
          basketCount: '{count} product(s) for purchase order',
          openModal: 'View and create purchase order',
          clearBasket: 'Clear purchase order selection',
        },
      },
      labels: {
        nombre: 'name',
        marca: 'brand',
        modelo: 'model',
        tamanio: 'size',
        deposito: 'warehouse',
        codigoBarras: 'barcode',
        codigoBarrasPropio: 'own barcode',
        codigoBarrasProveedor: 'supplier barcode',
        precioVenta: 'sale price',
        precioCompra: 'purchase price',
        precio: 'price',
        stock: 'stock',
        stockAlerta: 'alert level products',
        productosVencidos: 'expired products',
        fechaVencimiento: 'expiration date',
        fechaAlta: 'created',
        fechaCreacion: 'creation date',
        fechaUltimaModificacion: 'date last update',
        creadoPor: 'created by',
        ingresar: 'enter product',
        cantidad: 'quantity',
        value: 'Value',
        porcentaje: 'Percentage',
        descuento: 'discount',
        descuentoProveedor: 'Supplier Discount',
        ivaPorcentaje: 'VAT',
        porcentajeSobreCosto: 'Profit Margin',
        tipoRedondeo: 'Rounding Type',
        otrasCaracteristicas: 'Other characteristics',
        proveedor: 'Supplier',
        almacen: 'Warehouse',
      },
    },
  },
  es: {
    producto: {
      title: 'Administración de Producto',
      menuTitle: 'Productos',
      subtitle: 'Ver, buscar, crear, editar, y borrar Producto',
      creating: 'Creando Producto',
      editing: 'Modificando Producto',
      deleting: 'Eliminando Producto',
      showing: 'Detalles de Producto',
      addedToCsv: 'Producto agregado al csv',
      errorHasStock: 'El producto seleccionado tiene stock. No puede ser eliminado',
      filters: 'Filtros',
      filterSection: {
        identification: 'Identificación',
        numeric: 'Valores',
        state: 'Estado',
        deposito: 'Depósito',
        proveedor: 'proveedor',
      },
      filterDepositoAll: 'Todos los depósitos',
      operators: {
        label: 'Operador',
        gte: 'Mayor o igual',
        lte: 'Menor o igual',
        eq: 'Igual a',
      },
      actions: {
        createOferta: 'Crear Oferta',
        transferirStock: 'Transferir Stock',
        agregarStock: 'Agregar Stock',
        cambioMasivoPrecio: 'Cambio de Precios',
        edicionMasivaAtributos: 'Edición masiva (marca, modelo, tamaño)',
        clearFilters: 'Limpiar Filtros',
        applyFilters: 'Aplicar Filtros',
        columnasVisibles: 'Columnas visibles',
        seleccionarTodas: 'Seleccionar todas',
        limpiarColumnas: 'Limpiar',
        editarTabla: 'Editar tabla',
        addToPresupuestoPedido: 'Agregar a presupuesto/orden de venta',
        addToOrdenCompra: 'Agregar a orden de compra',
      },
      modals: {
        createOferta: {
          title: 'Crear Oferta',
          message: 'Está a punto de crear una oferta con {count} productos seleccionados. ¿Desea continuar?',
        },
        transferirStock: {
          title: 'Transferir Stock',
          depositoDestino: 'Depósito Destino',
          cantidad: 'Cantidad',
          stockDisponible: 'Stock Disponible',
          productosSeleccionados: 'Productos Seleccionados',
          errorCantidadRequerida: 'La cantidad es requerida',
          errorCantidadMinima: 'La cantidad debe ser mayor a 0',
          errorCantidadExcede: 'La cantidad no puede exceder el stock disponible',
          errorDepositoRequerido: 'El depósito destino es requerido',
          errorValidacion: 'Por favor verifique todos los campos y cantidades',
          errorTransferencia: 'Error al transferir stock',
          success: 'Stock transferido exitosamente',
          warningDepositosDiferentes: 'Los productos seleccionados son de depósitos diferentes. Por favor seleccione productos del mismo depósito.',
        },
        agregarStock: {
          title: 'Agregar Stock',
          productosSeleccionados: 'Productos Seleccionados',
          stockDisponible: 'Stock Disponible',
          cantidadAgregar: 'Cantidad a Agregar',
          nuevoStockFinal: 'Nuevo Stock Final',
          errorCantidadNegativa: 'La cantidad no puede ser negativa',
          errorValidacion: 'Ingrese al menos una cantidad para confirmar',
          success: 'Stock agregado correctamente',
          error: 'Error al agregar stock',
        },
        cambioMasivoPrecio: {
          title: 'Actualización Masiva de Precios',
          precioCompraGlobal: 'Precio de Compra',
          ivaGlobal: 'IVA',
          descuentoGlobal: 'Descuento Proveedor',
          margenGlobal: 'Margen sobre Costo',
          tipoRedondeo: 'Tipo de Redondeo',
          productosSeleccionados: 'Productos Seleccionados',
          precioVentaActual: 'Precio Actual',
          precioVentaNuevo: 'Precio Venta Nuevo',
          diferencia: 'Diferencia',
          success: 'Precios actualizados correctamente',
          error: 'Error al actualizar precios',
          hint: 'Los valores se aplican automáticamente a todos los productos. Puede editarlos individualmente en la tabla.',
        },
        edicionMasivaAtributos: {
          title: 'Edición masiva de atributos',
          otrasHint: 'Si escribe texto, se aplica a todos los productos seleccionados; déjelo vacío para no modificar este campo.',
          productosSeleccionados: 'Productos seleccionados',
          success: 'Productos actualizados correctamente',
          error: 'Error al actualizar productos',
        },
        presupuestoPedido: {
          title: 'Crear presupuesto u orden de venta desde productos',
          basketCount: '{count} producto(s) para presupuesto/orden de venta',
          openModal: 'Ver y crear presupuesto u orden de venta',
          clearBasket: 'Quitar selección para presupuesto/orden',
          cliente: 'Cliente',
          tipoDocumento: 'Tipo de documento',
          tipoPresupuesto: 'Presupuesto',
          tipoPedido: 'Orden de venta',
          producto: 'Producto',
          cantidad: 'Cantidad',
          precioUnitario: 'Precio unitario',
          subtotal: 'Subtotal',
          crear: 'Crear',
          cancelar: 'Cancelar',
          errorDeposito: 'Seleccione un depósito en su configuración de usuario para crear presupuestos o pedidos.',
          errorCliente: 'El cliente es requerido',
          errorItems: 'Agregue al menos un producto con cantidad ≥ 1',
        },
        ordenCompra: {
          basketCount: '{count} producto(s) para orden de compra',
          openModal: 'Ver y crear orden de compra',
          clearBasket: 'Quitar selección para orden de compra',
        },
      },
      labels: {
        nombre: 'nombre',
        marca: 'marca',
        modelo: 'modelo',
        tamanio: 'tamaño',
        deposito: 'Depósito',
        codigoBarras: 'codigo de barras',
        codigoBarrasPropio: 'Código de barras propio',
        codigoBarrasProveedor: 'codigo de barras del proveedor',
        precioVenta: 'precio de venta',
        precioCompra: 'precio de compra',
        precio: 'precio',
        stock: 'stock',
        stockAlerta: 'productos en nivel de alerta',
        productosVencidos: 'productos vencidos',
        fechaVencimiento: 'fecha de vencimiento',
        fechaAlta: 'fecha alta',
        fechaCreacion: 'fecha de creación',
        fechaUltimaModificacion: 'fecha última modificación',
        creadoPor: 'creado por',
        ingresar: 'ingresar producto',
        cantidad: 'cantidad',
        value: 'Valor',
        porcentaje: 'Porcentual',
        descuento: 'descuento',
        descuentoProveedor: 'Descuento Proveedor',
        ivaPorcentaje: 'IVA',
        porcentajeSobreCosto: 'Porcentaje sobre el costo',
        tipoRedondeo: 'Tipo de Redondeo',
        otrasCaracteristicas: 'Otras características',
        proveedor: 'proveedor',
        almacen: 'almacén',
      },
    },
  },
  pt: {
    producto: {
      title: 'Administração de Producto',
      menuTitle: 'Produtos',
      subtitle: 'Ver, buscar, criar, editar e usar Producto',
      creating: 'Criando Producto',
      editing: 'Edição Producto',
      deleting: 'Apagando Producto',
      showing: 'Detalhes do Producto',
      addedToCsv: 'Producto added to csv',
      errorHasStock: 'The selected producto has stock. It cannot be deleted',
      filters: 'Filtros',
      filterSection: {
        identification: 'Identificação',
        numeric: 'Valores',
        state: 'Estado',
        deposito: 'Depósito',
        proveedor: 'Fornecedor',
      },
      filterDepositoAll: 'Todos os depósitos',
      operators: {
        label: 'Operador',
        gte: 'Maior ou igual',
        lte: 'Menor ou igual',
        eq: 'Igual a',
      },
      actions: {
        createOferta: 'Criar Oferta',
        transferirStock: 'Transferir Estoque',
        agregarStock: 'Adicionar Estoque',
        cambioMasivoPrecio: 'Alteração em Massa de Preços',
        edicionMasivaAtributos: 'Edição em massa (marca, modelo, tamanho)',
        clearFilters: 'Limpar Filtros',
        applyFilters: 'Aplicar Filtros',
        columnasVisibles: 'Colunas visíveis',
        seleccionarTodas: 'Selecionar todas',
        limpiarColumnas: 'Limpar',
        editarTabla: 'Editar tabela',
        addToPresupuestoPedido: 'Adicionar a orçamento/pedido de venda',
        addToOrdenCompra: 'Adicionar a ordem de compra',
      },
      modals: {
        createOferta: {
          title: 'Criar Oferta',
          message: 'Você está prestes a criar uma oferta com {count} produtos selecionados. Deseja continuar?',
        },
        transferirStock: {
          title: 'Transferir Estoque',
          depositoDestino: 'Depósito Destino',
          cantidad: 'Quantidade',
          stockDisponible: 'Estoque Disponível',
          productosSeleccionados: 'Produtos Selecionados',
          errorCantidadRequerida: 'A quantidade é obrigatória',
          errorCantidadMinima: 'A quantidade deve ser maior que 0',
          errorCantidadExcede: 'A quantidade não pode exceder o estoque disponível',
          errorDepositoRequerido: 'O depósito destino é obrigatório',
          errorValidacion: 'Por favor verifique todos os campos e quantidades',
          errorTransferencia: 'Erro ao transferir estoque',
          success: 'Estoque transferido com sucesso',
          warningDepositosDiferentes: 'Os produtos selecionados são de depósitos diferentes. Por favor selecione produtos do mesmo depósito.',
        },
        agregarStock: {
          title: 'Adicionar Estoque',
          productosSeleccionados: 'Produtos Selecionados',
          stockDisponible: 'Estoque Disponível',
          cantidadAgregar: 'Quantidade a Adicionar',
          nuevoStockFinal: 'Novo Estoque Final',
          errorCantidadNegativa: 'A quantidade não pode ser negativa',
          errorValidacion: 'Informe pelo menos uma quantidade para confirmar',
          success: 'Estoque adicionado com sucesso',
          error: 'Erro ao adicionar estoque',
        },
        cambioMasivoPrecio: {
          title: 'Atualização em Massa de Preços',
          precioCompraGlobal: 'Preço de Compra',
          ivaGlobal: 'IVA',
          descuentoGlobal: 'Desconto Fornecedor',
          margenGlobal: 'Margem sobre Custo',
          tipoRedondeo: 'Tipo de Arredondamento',
          productosSeleccionados: 'Produtos Selecionados',
          precioVentaActual: 'Preço Atual',
          precioVentaNuevo: 'Preço Novo',
          diferencia: 'Diferença',
          success: 'Preços atualizados com sucesso',
          error: 'Erro ao atualizar preços',
          hint: 'Os valores são aplicados automaticamente a todos os produtos. Você pode editá-los individualmente na tabela.',
        },
        edicionMasivaAtributos: {
          title: 'Edição em massa de atributos',
          otrasHint: 'Se digitar texto, ele será aplicado a todos os produtos selecionados; deixe vazio para não alterar este campo.',
          productosSeleccionados: 'Produtos selecionados',
          success: 'Produtos atualizados com sucesso',
          error: 'Erro ao atualizar produtos',
        },
        presupuestoPedido: {
          title: 'Criar orçamento ou pedido de venda a partir de produtos',
          basketCount: '{count} produto(s) para orçamento/pedido',
          openModal: 'Ver e criar orçamento ou pedido',
          clearBasket: 'Limpar seleção para orçamento/pedido',
          cliente: 'Cliente',
          tipoDocumento: 'Tipo de documento',
          tipoPresupuesto: 'Orçamento',
          tipoPedido: 'Pedido de venda',
          producto: 'Produto',
          cantidad: 'Quantidade',
          precioUnitario: 'Preço unitário',
          subtotal: 'Subtotal',
          crear: 'Criar',
          cancelar: 'Cancelar',
          errorDeposito: 'Selecione um depósito na configuração do usuário.',
          errorCliente: 'Cliente obrigatório',
          errorItems: 'Adicione pelo menos um produto com quantidade ≥ 1',
        },
        ordenCompra: {
          basketCount: '{count} produto(s) para ordem de compra',
          openModal: 'Ver e criar ordem de compra',
          clearBasket: 'Limpar seleção da ordem de compra',
        },
      },
      labels: {
        nombre: 'nome',
        marca: 'marca',
        modelo: 'modelo',
        tamanio: 'tamanho',
        deposito: 'depósito',
        codigoBarras: 'próprio código de barras',
        codigoBarrasPropio: 'Código de barras próprio',
        codigoBarrasProveedor: 'código de barras do fornecedor',
        precioVenta: 'preço de venda',
        precioCompra: 'preço de compra',
        precio: 'preço próprio',
        stock: 'estoque',
        stockAlerta: 'produtos em nível de alerta',
        productosVencidos: 'produtos vencidos',
        fechaVencimiento: 'data de validade',
        fechaAlta: 'fecha alta',
        fechaCreacion: 'data de criação',
        fechaUltimaModificacion: ' data da última modificação',
        creadoPor: 'criado pela',
        ingresar: 'enter product',
        cantidad: 'cantidad',
        value: 'Valor',
        porcentaje: 'Porcentaje',
        descuento: 'descuento',
        descuentoProveedor: 'Desconto Fornecedor',
        ivaPorcentaje: 'IVA',
        porcentajeSobreCosto: 'Margem de Lucro',
        tipoRedondeo: 'Tipo de Arredondamento',
        otrasCaracteristicas: 'Outras características',
        proveedor: 'Fornecedor',
        almacen: 'Armazém',
      },
    },
  }
}

export default messages
